export default __webpack_public_path__ + "static/header-95a2a0559c2757fb95dfb148c4452614.png";